<div>
  @for (error of roleErrors$ | async; track error.message) {
    <stb-alert [surfaceVariant]="'surface-1'" width="fluid" [type]="'error'" [text]="error.message | fms"></stb-alert>
  }
</div>
